import { BitrixVue } from 'ui.vue';

BitrixVue.cloneComponent('Step14', 'Steps', {
	data() {
		return {
			step14: null,
			activeRadio: 0,
			selectedDoorStop: null,
			selectedDoorStopColor: null,
			showStep: false,
		};
	},
	created() {
		this.getDataStep();
	},
	props: [],
	methods: {
		setActiveRadio(value) {
			this.activeRadio = value;
			if (!this.activeRadio) {
				this.selectedDoorStop = null;
				this.selectedDoorStopColor = null;
			}
		},
		setActiveSlide(index) {
			this.selectedDoorStop = index;
		},
		getDataStep: function () {
			let context = this;
			let store = { ...this.$store.state.position };
			delete store.renderImage;
			let req = BX.ajax.runComponentAction('mworks:configurator', 'getDataStep14', {
				mode: 'class',
				method: 'post',
				data: {
					position: store,
				},
			});

			req.catch(function (response) {
			});

			req.then((response) => {
				if (response.status == 'success') {
					context.step14 = response.data.result;
					const active = context.step14.doorStopRadio.filter((item) => {
						if (item.value === val) return item;
					});

					if (active.length) {
						showStep = true;
						context.setPropPosition({ doorStopRadio: active[0] });
					} else {
						showStep = false;
					}
				}
			});
		},
		isDataStep: function () {
			return this.step14;
		},
	},
	watch: {
		activeRadio: function (val) {
			this.step14.doorStopRadio.forEach((item) => {
				item.value === val ? this.setPropPosition({ doorStopRadio: item }) : null;
			});

			if (!val) {
				this.setPropPosition({
					doorStopModel: null,
					doorStopColor: null,
				});
			}
		},
		selectedDoorStop: function (val) {
			if (val !== null) {
				this.setPropPosition({ doorStopModel: this.step14.doorStop[val] });
			}
		},
		selectedDoorStopColor: function (val) {
			if (val !== null) {
				this.setPropPosition({
					doorStopColor: this.step14.doorStopColors[val],
				});
			}
		},
	},
	template: `
<div class="config-block" v-if="showStep && isDataStep()">
	<div class="config-block__inner">
		<div class="config-block__wrap">
			<ConfigBlockWrapTitle :tippyContent="step14.doorStopDescription">Дверной ограничитель</ConfigBlockWrapTitle>
			<RadioGroup :options="step14.doorStopRadio" name="door_stop_radio"
				v-on:selectedValue="setActiveRadio" />
		</div>
		<div class="config-block__inner" v-show="activeRadio">
			<div class="config-block__wrap mt-48">
				<div class="config-block__wrap-title">Модель</div>
				<DoubleInputNumeric class="w-100p sm:w-50p" minValue="1000" maxValue="10000" label="Цена, руб." />
				<div class="config-block__row mt-20">
					<Swiper :basicSlidesPerView="1.3" :basicSpaceBetween="20" :breakpointsForSlides="3">
						<div class="swiper-slide" v-for="(slide, index) of step14.doorStop">
							<SimpleItem :image="slide.image" :price="slide.price" :priceType="2" :key="index"
								:class="{active: selectedDoorStop === index}" v-on:setActive="setActiveSlide(index)" />
						</div>
					</Swiper>
				</div>
			</div>
			<div class="config-block__wrap mt-48" v-show="step14.doorStopColors">
				<div class="config-block__wrap-title">Цвет покраски</div>
				<ConfigBlockColors>
					<Color v-for="(color, index) of step14.doorStopColors" :color="color" :key="index"
						:class="{active: selectedDoorStopColor === index}"
						v-on:setActiveColor="selectedDoorStopColor = index" />
				</ConfigBlockColors>
			</div>
		</div>
	</div>
</div>
`,
});
